import { EventName } from 'src/context/userProfileContext'
import { ComponentName } from 'src/utils/datahubDefaultEvent'

const useUserProfileEvents = () => {
  const onOpen = (userUcode?: string, componentName?: ComponentName) => {
    window.dispatchEvent(
      new CustomEvent(EventName.OPEN_PROFILE, {
        detail: {
          ucode: userUcode,
          componentName
        }
      })
    )
  }

  const onClose = () => {
    window.dispatchEvent(new CustomEvent(EventName.CLOSE_PROFILE))
  }

  return { onOpen, onClose }
}

export default useUserProfileEvents
